// @unocss-include
'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'clsx';
import { useEffect, useState } from 'react';
import { Button } from '../button/Button.js';
import { CollapsibleContent, CollapsibleRoot } from '../collapsible/index.js';
export function ActionButton(_a) {
    var { children, className, visible = true, asChild } = _a, rest = __rest(_a, ["children", "className", "visible", "asChild"]);
    // this rather convoluted logic is meant to do:
    // - when button goes invisible, wait for collapse and then
    //   stop rendering
    // - when button goes visible, render immediately and
    //   set collapsible open next frame.
    const [render, setRender] = useState(visible);
    useEffect(() => {
        if (!visible) {
            const timeout = setTimeout(() => {
                setRender(visible);
            }, 300);
            return () => clearTimeout(timeout);
        }
        else {
            setRender(visible);
        }
    }, [visible]);
    if (!render && !visible) {
        return null;
    }
    return (_jsx(CollapsibleRoot, { open: !visible ? false : render, children: _jsx(CollapsibleContent, { "data-horizontal": true, children: _jsx(Button, Object.assign({ size: "small", className: classNames('layer-variants:border-gray-dark layer-variants:font-normal layer-variants:whitespace-nowrap layer-variants:m-2 layer-variants:flex layer-variants:flex-row layer-variants:gap-2 layer-variants:items-center layer-variants:py-0.25 layer-variants:rounded-md layer-variants:mx-1 layer-variants:min-h-7.5', className), asChild: asChild }, rest, { children: children })) }) }));
}
//# sourceMappingURL=ActionButton.js.map